import React from "react";
import CommonModal from "../../components/Modal";
import { ModalProps } from "../../components/Modal/Modal.types";
import { Icon } from "Components";
import Alert from "PhishingManager/components/Alert";
import { Steps } from "antd";
import { useTranslation } from "react-i18next";

const { Step } = Steps;

const TestCampaignModal: React.FC<ModalProps & { testEmailsCount: number }> = ({
    testEmailsCount,
    open,
    onClose,
    onConfirm,
}) => {
    const { t } = useTranslation();

    return (
        <CommonModal
            visible={open}
            cancelText={null}
            confirmText={t("phishingManager.testCampaignModal.confirmText")}
            parentClass="test-campaign-modal"
            iconType={null}
            onClose={onClose}
            onConfirm={onConfirm}>
            <div className="pm-icon-box">
                <div className="pm-icon-wrapper">
                    <Icon type={"check"} />
                </div>
            </div>
            <p className="pm-modal-title-text">
                {t("phishingManager.testCampaignModal.title")}
            </p>
            <p className="pm-modal-title-desc">
                {t("phishingManager.testCampaignModal.description")}
            </p>
            <div className="campaign-status-container">
                <span>{t("phishingManager.testCampaignModal.whatHappensNext")}</span>
                <Steps direction="vertical" current={1}>
                    <Step
                        icon={null}
                        title={t("phishingManager.testCampaignModal.steps.testEmailsSent.title")}
                        description={t(
                            "phishingManager.testCampaignModal.steps.testEmailsSent.description",
                            { count: testEmailsCount }
                        )}
                    />
                    <Step
                        icon={<Icon type={"stepInProgress"} />}
                        title={t("phishingManager.testCampaignModal.steps.reviewResults.title")}
                        description={t(
                            "phishingManager.testCampaignModal.steps.reviewResults.description"
                        )}
                    />
                    <Step
                        title={t("phishingManager.testCampaignModal.steps.releaseFullCampaign.title")}
                        description={t(
                            "phishingManager.testCampaignModal.steps.releaseFullCampaign.description"
                        )}
                    />
                </Steps>
            </div>
            <Alert
                iconType="phishingManagerWarningModal"
                title={t("phishingManager.testCampaignModal.alert.title")}
                subtitle={t("phishingManager.testCampaignModal.alert.subtitle")}
            />
        </CommonModal>
    );
};

export default TestCampaignModal;